<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";
import { cardWasCreatedOnDifferentBoard, isActionVisible } from "@/components/utils/actions";
import { injectStrict } from "@/utils/vue";

import ChangeProject from "./ChangeProject.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);
const isVisible = computed(
  () =>
    isActionVisible("almSource", card, board.value) &&
    !cardWasCreatedOnDifferentBoard(card, board.value) &&
    board.value.almSources.length > 1,
);
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.setAlmSource">
    <ChangeProject />
  </ActionMenuDropdown>
</template>
